import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import vuetify from './plugins/vuetify'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import globalAxios from './api/GlobalAxios'
import './styles/global.css'

Vue.use(VueClipboard)

Vue.use(VuePlyr, {
  plyr: {}
})

Vue.config.productionTip = false

// 번역 데이터를 로드한 후 Vue 인스턴스를 마운트
async function loadTranslations() {
  try {
    const response = await globalAxios.get('/api/translation_langs')
    const translations = response.data
    store.commit('setTranslations', translations)
    return translations
  } catch (error) {
    console.error('번역 데이터 로드 실패:', error)
    throw error
  }
}

async function loadLanguageOptions() {
  try {
    const response = await globalAxios.get('/api/translation_languages')
    const languages = Array.isArray(response.data) ? response.data : []
    store.commit('setLanguageOptions', languages)
    if (languages.length) {
      const current = store.state.language
      const hasCurrent = current && languages.some(lang => lang.code === current)
      if (!hasCurrent) {
        store.commit('setLanguage', languages[0].code)
      }
    }
  } catch (error) {
    console.error('언어 목록 로드 실패:', error)
  }
}

Promise.all([loadTranslations(), loadLanguageOptions()]).then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
  }).$mount('#app')
}).catch(error => {
  console.error('앱 초기화 실패:', error)
})
